// Password gate for protected menu areas (affiliates / affiliate dashboards /
// lead distribution). The unlock lives ONLY in memory and relocks whenever the
// user leaves the gated area, so every fresh entry asks for the password again.
export default {
  namespaced: true,
  state: {
    unlocked: false,
    pendingRoute: null,
  },
  getters: {
    isUnlocked: state => state.unlocked,
    pendingRoute: state => state.pendingRoute,
  },
  mutations: {
    PROMPT(state, fullPath) {
      state.pendingRoute = fullPath;
    },
    CLEAR_PROMPT(state) {
      state.pendingRoute = null;
    },
    UNLOCK(state) {
      state.unlocked = true;
      state.pendingRoute = null;
    },
    RELOCK(state) {
      state.unlocked = false;
    },
  },
};
